'use strict';

angular.module('mobile-apps')
	.directive('moveToGroupButton',[
		'EntryMain',
		'Groups',
		'LanguageEntries',
		'$stateParams',
		'$timeout',
		'$rootScope',
		'Utilities',
		'SweetAlert',
		function(
			EntryMain,
			Groups,
			LanguageEntries,
			$stateParams,
			$timeout,
			$rootScope,
			Utilities,
			SweetAlert
		) {
		return {
			scope:
			{
				postActionCallback: '&', // Optional
				entries: '='
			},
			templateUrl: 'modules/mobile-apps/views/move-to-group-button.client.directive.html',

			link: function (scope, element, attrs) {
				scope.status = {isOpen: false, changed: false};
				scope.filterString = '';
				scope.displayGroups = [];


				/**
				 * Returns array of currently selected entries
         		 */
				function getSelectedEntries() {
					var selectedEntries = [];
					scope.entries.forEach(function(entry) {
						if (entry.selected === true) {
							selectedEntries.push(entry);
						}

						if(entry.linkedKeys && entry.linkedKeys.length) {
							entry.linkedKeys.forEach(function(entryKey) {
								selectedEntries.push(EntryMain.allValues[entryKey]);
							});
						}
					});

					return selectedEntries;
				}


				/**
				 * Initializes the tag-list
				 */
				scope.init = function() {
					// Init displayGroups
					scope.displayGroups.length = 0;
					Object.keys(EntryMain.groups).forEach(function(groupId) {
						scope.displayGroups.push(EntryMain.groups[groupId]);
					});
				};


				/**
				 * Opens the dropdown and then initializes the group-list
		         */
				scope.displayDropdown = function($event) {
					$event.preventDefault();
					$event.stopPropagation();
					scope.status.isOpen = true;
					scope.init();
				};


				/**
				 * Moves the currently selected translations to the given group
				 */
				scope._moveToGroup = function(groupId) {
					scope.status.isOpen = false;
					var selectedEntries = getSelectedEntries();

					var entryKeys = selectedEntries.map(function(entry) { return entry.key; } );

					Groups.moveToGroup({
						mobileApp: $stateParams.mobileAppId,
						_id: groupId,
						entryKeys: entryKeys
					}, function (response) {
						$rootScope.$broadcast('entriesChanged');

						if (angular.isFunction(scope.postActionCallback)) {
							scope.postActionCallback(entryKeys, entryKeys);
						}

						Utilities.showMessage(
							'Success!',
							'The translations got moved to group: ' +  EntryMain.groups[groupId].name,
							'success'
						);

					}, function (errorResponse) {

						Utilities.showMessage(
							'Error!',
							'Sorry something went wrong',
							'error'
						);

					});
				};


				/**
				 * Moves the currently selected translations to a given group
				 * after the user confirmed a dialog
				 */
				scope.moveToGroup = function(groupId) {

					SweetAlert.swal(
						{
							title             : 'Are you sure?',
							text              : 'This will move all the selected translations into group: ' + EntryMain.groups[groupId].name,
							type              : 'warning',
							showCancelButton  : true,
							confirmButtonColor: '#DD6B55',
							confirmButtonText : 'Yes, move!',
							cancelButtonText  : 'No, cancel!',
							closeOnConfirm    : true,
							closeOnCancel     : true
						},
						function (isConfirm) {
							if (isConfirm) {
								scope._moveToGroup(groupId);
							}
						}
					);

				};


			}
		};
	}]);
